import appConfig from '@/features/app/constants/app-config';
import useCanClientUseCookieTokenStorage from '@/features/auth/hooks/useCanClientUseCookieTokenStorage';
import Cookies from 'js-cookie';
import { useCallback } from 'react';
import useFeatureFlags from '@/features/feature-flags/hooks/useFeatureFlags';

export default function useHasUserLoggedInBefore() {
  const featureFlags = useFeatureFlags();
  const canClientUseCookieStorage = useCanClientUseCookieTokenStorage();

  return useCallback(() => {
    if (canClientUseCookieStorage) return true;
    if (
      featureFlags.auth.useLegacyTokenStorage &&
      Cookies.get(appConfig.authTokenKey) !== undefined
    )
      return true;
    return false;
  }, [featureFlags.auth.useLegacyTokenStorage, canClientUseCookieStorage]);
}
